"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEFAULT_DATE_FORMAT_TO_DISPLAY = exports.DEFAULT_DATE_FORMAT_FOR_CALENDAR = void 0;
const DEFAULT_DATE_FORMAT_TO_DISPLAY = exports.DEFAULT_DATE_FORMAT_TO_DISPLAY = 'ddd, MMM DD';
const DEFAULT_DATE_FORMAT_FOR_CALENDAR = exports.DEFAULT_DATE_FORMAT_FOR_CALENDAR = 'YYYY/MM/DD';